import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateTipoAjusteContratoRequest extends CreateKeyValueRequest {
  public acronimo!: string
}
